import { render, staticRenderFns } from "./PmlProperty.vue?vue&type=template&id=3c3fb7c4&scoped=true&"
import script from "./PmlProperty.vue?vue&type=script&lang=js&"
export * from "./PmlProperty.vue?vue&type=script&lang=js&"
import style0 from "./PmlProperty.vue?vue&type=style&index=0&id=3c3fb7c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3fb7c4",
  null
  
)

export default component.exports